import { render } from "./App.vue?vue&type=template&id=148a6052"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=148a6052&lang=css"

import exportComponent from "/Users/mac/Documents/workspaces/view-store/view-reno-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__